import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query Users($page: Int, $pageSize: Int) {
  users(page: $page, pageSize: $pageSize) {
    _totalCount
    pageSize
    users {
      id
      role
      operatorTeamId
      overseerTeams {
        id
        name
      }
      name
      email
      firstName
      lastName
      middleName
      displayName
      absenceReason
      fullName
      avgVote
      logged
      avatarUrl
      ready
      banned
      ucceInfo {
        uccePeripheralId
        uccePeripheralFirstName
        uccePeripheralLastName
        uccePeripheralLogin
      }
      useExpress
      ctsUserId
      ldapUser
      ldapStatus
      external
    }
  }
}`;

function getUsers({ page, pageSize }) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.users);
}

export default getUsers;
